export default __webpack_public_path__ + "static/search-bottom-desktop-45e6bf76f46e68a8b430bfdecf4243b5.jpg";